module.exports = __webpack_public_path__ + "img/fruit-blackberries-190x100.13a3aa22.jpg";